<template>
  <path d="M210.410732 410.339412H68.474355a68.421137 68.421137 0 0 0-68.182617 74.128577l39.866898 476.801278a68.438174 68.438174 0 0 0 68.182617 62.730733h102.069479a34.210568 34.210568 0 0 0 34.210568-34.210568V444.567017a34.227605 34.227605 0 0 0-34.210568-34.227605zM953.792071 410.339412H647.583632C752.941279 19.98456 574.340986 0 574.340986 0c-75.781179 0-60.07294 60.004792-65.763343 69.971516 0 144.883801-116.380673 265.881539-172.90989 316.107015a67.875948 67.875948 0 0 0-22.608279 50.821775v552.889126c0 18.894183 15.316385 34.210568 34.210569 34.210568h399.99787a136.654865 136.654865 0 0 0 122.616265-76.053773c31.143884-63.020365 69.290031-154.509783 93.602023-229.660589 23.528284-72.697458 44.90989-162.875017 57.449222-226.287235a68.370025 68.370025 0 0 0-67.143352-81.658991z"></path>
</template>

<script>
    export default {
        name: "icon-good"
    }
</script>

<style scoped>

</style>
